import { createAction } from 'redux-actions';

const PREFIX = 'EDIT_PROFILE';

export const updateTFProfile = createAction(`${PREFIX}/updateTFProfile`, (nextProfile, file, formik) => ({ nextProfile, file, formik }));
export const updateTFProfileInfo = createAction(`${PREFIX}/updateTFProfileInfo`, nextProfile => nextProfile);
export const updateTfImage = createAction(`${PREFIX}/updateTfImage`, (file, type, imagePath) => ({ file, type, imagePath }));
